export const MOBILE_MENU_TEXTS = {
  menuTitle: 'Меню',
  accountTitle: 'Личный кабинет',
  chat: 'Есть вопросы? Написать в чат',
} as const;
